<template>
  <v-dialog v-model="isActive" @keydown.esc="isActive = false" max-width="400px" lazy persistent>
    <v-card>

      <v-card-title class="title">{{ $t('inputs.immagine.ritaglia_immagine') }}</v-card-title>

      <v-card-text>
        <vue-cropper
          ref="cropper"
          :src="src"
          :aspect-ratio="aspectRatio"
          :check-cross-origin="false"
          :view-mode="0"
          :min-container-width="-1">
        </vue-cropper>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="accent" flat @click="close">{{ $t('azioni.annulla') }}</v-btn>
        <v-btn color="accent" @click="confirm">{{ $t('azioni.conferma') }}</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import Toggleable from '@/mixins/toggleable'
import 'blueimp-canvas-to-blob'

const VueCropper = () => import(/* webpackChunkName: "vue-cropperjs" */'vue-cropperjs')

export default {
    name: 'CropperDialog',
    mixins: [Toggleable],
    components: { VueCropper },
    props: {
        src: String,
        aspectRatio: {
            type: Number,
            default: NaN
        }
    },
    watch: {
        src (val) {
            if (this.$refs.cropper) {
                this.$refs.cropper.replace(val)
            }
        }
    },
    methods: {
        confirm () {
            this.$refs.cropper.getCroppedCanvas({ fillColor: '#fff' })
                .toBlob((blob) => {
                    //  Polyfill per IE11 e Edge
                    // eslint-disable-next-line
                    let File = window.File
                    try {
                        // eslint-disable-next-line
                        new File([], '')
                    } catch (e) {
                        File = class File extends Blob {
                            constructor (chunks, filename, opts = {}) {
                                super(chunks, opts)
                                this.lastModified = new Date()
                                this.name = filename
                            }
                        }
                    }

                    //  Converto il tipo Blob in File per l'upload nella form
                    let file = new File([blob], 'uploadedImage', { type: 'image/jpeg' })

                    this.$emit('return', file)
                    this.isActive = false
                }, 'image/jpeg')
        },
        close () {
            this.$emit('close')
            this.isActive = false
        }
    }
}
</script>
